

<template>
  <div>
<FormManager
  :prettyEndPoint="'/api/llm/field/pretty/' + llm_prompt_field.id"
  :initialFormValues="llm_prompt_field"
  @save="save"
  :events="events"
  :edit_mode="false"
  :edit_mode_lock="false"
/>

</div>
</template>

<script>
export default {
  name: "LlmPromptField",
  props: ['llm_prompt_field'],
  data() {
    return {
      events: {
        use: {
          label: "Save" ,
          event: "save"
        },
        cancel: {
          label: "Cancel",
          event: "cancel"
        }
      },
    }
  },
  mounted() {
    console.log(this.llm_prompt_field)
  },
  methods: {
    save(values) {
      axios.post('/api/llm/field/' + this.llm_prompt_field.id, {
        values: values
      })
          .then(response => {
            console.log("saved")
          })
          .catch(error => {
            console.log('oops could not save')
          })
    },
  }
}

</script>

<style scoped>

</style>